/**
 * #571 (14/10/2026): os textos da escolha do cliente na tela de Vínculos — num módulo puro (sem JSX), para a tela e os
 * testes lerem o MESMO texto.
 */
import type { Client } from '@/lib/clients-store';

/** O nome que a tela mostra do cliente daqui: o fantasia; sem ele, a razão social; sem os dois, o `nome` da busca. */
export function nomeDoCliente(c: Pick<Client, 'nome' | 'nomeFantasia' | 'razaoSocial'>): string {
  return (c.nomeFantasia ?? '').trim() || (c.razaoSocial ?? '').trim() || c.nome;
}

/** "Campinas/SP", ou `null` quando o cadastro não tem cidade. */
export function cidadeDoCliente(c: Pick<Client, 'endereco'>): string | null {
  const e = (c.endereco ?? {}) as { cidade?: unknown; uf?: unknown };
  const cidade = typeof e.cidade === 'string' ? e.cidade.trim() : '';
  const uf = typeof e.uf === 'string' ? e.uf.trim() : '';
  if (!cidade) return null;
  return uf ? `${cidade}/${uf}` : cidade;
}

/**
 * A pergunta antes de gravar, como o Matheus pediu: *"Vincular le ville (Auvo) a CONDOMINIO LE VILLE?"*.
 */
export function fraseDaConfirmacao(nomeDeFora: string | null, sistema: 'auvo' | 'omie', cliente: string): string {
  const deFora = (nomeDeFora ?? '').trim() || '(cadastro sem nome)';
  return `Vincular ${deFora} (${sistema === 'auvo' ? 'Auvo' : 'Omie'}) a ${cliente}?`;
}
